export const ASSIGN_CONTACTS_TO_USER = 1;
export const ASSIGN_CONTACTS_TO_RING_GROUP = 2;
